import React from 'react';
import { StyleSheet, View } from 'react-native';
import { theme } from '@sweetgreen/garnish';

import { CreditMenuItem } from '@order/components';
import { useLocalizationContext } from '@order/Localization';

export const GiftCodeSelector = ({ onSelect }: Selector) => {
  const { t } = useLocalizationContext();

  return (
    <View style={styles.padding}>
      <CreditMenuItem
        testID="scan-to-pay.gift-code.selector"
        accessibilityLabel={t('account.credit.a11y-label')}
        accessibilityHint={t('account.credit.a11y-label')}
        iconName="IconPromo"
        title={t('account.credit.field-placeholder')}
        onPress={onSelect}
      />
    </View>
  );
};

type Selector = {
  readonly onSelect: () => void;
};

const styles = StyleSheet.create({
  padding: {
    paddingHorizontal: theme.spacing.small,
  },
});
